import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnChanges, OnInit, signal } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { Observable } from 'rxjs';

import { NOTIFICATION_LADDER_VISIBLE, NOTIFICATION_LADDER_VISIBLE_PROVIDER } from '../../../services/digital/acca-boost-notification-sync.service';
import { CarouselAnimationService } from '../../../services/digital/carousel-animation.service';
import { BaseAccaBoostLadderCarouselComponent, ILadderItem } from '../../acca-boost-ladder-carousel/base-acca-boost-ladder-carousel.component';

@Component({
    selector: 'bs-acca-boost-ladder-carousel',
    templateUrl: './acca-boost-ladder-carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NOTIFICATION_LADDER_VISIBLE_PROVIDER, CarouselAnimationService],
    styleUrls: ['./acca-boost-ladder-carousel.component.scss'],
    standalone: false,
})
export class AccaBoostLadderCarouselComponent extends BaseAccaBoostLadderCarouselComponent implements OnInit, OnChanges {
    @Input() usLadderEnabled = false;

    maxItem: ILadderItem;
    ladderItems = signal<ILadderItem[]>([]);
    resetLadderItemDuration: number;

    @HostBinding('class.acca-boost-ladder-carousel') class = true;

    constructor(
        @Inject(NOTIFICATION_LADDER_VISIBLE) notificationAnimationDone$: Observable<void>,
        changeRef: ChangeDetectorRef,
        protected timerService: TimerService,
    ) {
        super(notificationAnimationDone$, changeRef);
    }

    ngOnInit(): void {
        this.setCarouselProps();
        this.vm = this.mapModel();
        this.vm = this.updateModel();
        this.resetLadderItems();
        this.resetLadderItemDuration = this.usLadderEnabled ? 0 : 1500;
    }

    ngOnChanges(changes: ISimpleChanges<AccaBoostLadderCarouselComponent>): void {
        if (!changes?.pickCount?.firstChange) {
            const offsetChanged = this.setCarouselProps();
            const lastItem = this.items[this.items.length - 1];
            this.endReached = this.pickCount > lastItem.numberOfLegs;
            if (!this.endReached) {
                this.vm = this.updateModel();

                if (changes?.pickCount?.previousValue! < changes?.pickCount?.currentValue!) {
                    this.setLadderItems();
                } else {
                    this.resetLadderItems();
                }
            }
            if (!offsetChanged) {
                // if offset hasn't changed, update model right away
                this.vm = this.updateModel();
            }
        }
    }

    protected resetLadderItems() {
        this.ladderItems.set([]);
        const vm2 = this.vm.slice(0, this.vm.length - 1);
        this.maxItem = this.vm[this.vm.length - 1];

        if (!this.maxItem.selected) {
            const firstItem = vm2.find((t) => t.selected);
            const secondItem = vm2.find((t) => t.numberOfLegs === this.pickCount + 1);

            if (firstItem) {
                this.ladderItems.update((items) => [...items, firstItem]);
            }
            if (secondItem) {
                this.ladderItems.update((items) => [...items, secondItem]);
            }
        }
    }

    protected setLadderItems() {
        this.ladderItems.set([]);
        const vm2 = this.vm.slice(0, this.vm.length - 1);
        this.maxItem = this.vm[this.vm.length - 1];

        if (!this.maxItem.selected) {
            const firstItem = vm2.find((t) => t.numberOfLegs === this.pickCount - 1);
            const secondItem = vm2.find((t) => t.selected);

            if (firstItem) {
                this.ladderItems.update((items) => [...items, firstItem]);
            }
            if (secondItem) {
                this.ladderItems.update((items) => [...items, secondItem]);
            }
        } else {
            this.ladderItems.update((item) => [...item, vm2[vm2.length - 1]]);
        }

        this.timerService.setTimeout(() => {
            this.resetLadderItems();
        }, this.resetLadderItemDuration);
    }
}
